const config = {
  troodyAdminBase: process.env.VUE_APP_TROODY_ADMIN_BASE,
  troodyAuthBase: process.env.VUE_APP_TROODY_AUTH_BASE,
  troodyApiBase: process.env.VUE_APP_TROODY_API_BASE,
}

export default config
